{
  "selectAsField": "Sélectionner \"{value}\" comme {fieldName}",
  "typeToSearchField": "Tapez pour rechercher un(e) {fieldName}",
  "licenseFieldLabel": "Sélectionner la plaque d'immatriculation (ex. 215BG2)",
  "licenseFieldName": "Plaque d'immatriculation",
  "licensePlaceholder": "Rechercher par plaque d'immatriculation",
  "dotFieldLabel": "Sélectionner le numéro DOT",
  "dotFieldName": "Numéro DOT",
  "dotPlaceholder": "Rechercher par numéro DOT"
}
